<template>
  <!-- 活动页面 -->
  <div class="box1">
    <!-- 主体 -->
    <div class="Core">
      <div class="swiper-container">
        <div class="swiper-wrapper">
          <div
            class="swiper-slide firm-clickable"
            v-for="(item, index) in datalist"
            :key="index"
            @click="handelClick(item)"
          >
            <div class="box">
              <div class="picture">
                <img :src="item.imgUrl" alt="" />
              </div>
              <div class="Instructions" v-if="item.status == '1'">
                <div class="Instructions-box">
                  <p>
                    {{ item.title }}<span v-if="item.onOrOff == 1">进行中</span
                    ><span v-else style="backgroundColor:#EEEEEE;color:#333333">未开启</span>
                  </p>
                  <!-- <p>{{ item.time }}</p>
                  <p>
                    {{ item.data }}
                  </p> -->
                </div>
              </div>
              <div class="Instructions" v-else>
                <p class="more">{{ item.data }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { homePageGetPersonCarSafeActivityInfo } from "../../../assets/api/indexl";
import Swiper from "swiper";
import "swiper/css/swiper.min.css";
export default {
  components: {},
  data() {
    return {
      input: "", // 搜索
      datalist: [
        // 车险暂时隐藏
        // {
        //   title: "车险预购活动",
        //   time: "活动时间：2024年8月28日 00：00 - 2025年8月28日 00：00",
        //   data: "活动内容：在活动期间，但凡参加车险活动者购买对应的车险全场2折起",
        //   status: "1",
        //   onOrOff: "0",
        //   id: "1",
        //   imgUrl: require('@/assets/imgs/img/geren-SVG/car-insurance.svg'),
        // },
        {
          data: "更多活动即将来临",
          status: "2",
          imgUrl: require('@/assets/imgs/img/geren-SVG/activity.svg'),
        },
      ],
    };
  },
  created() {},
  mounted() {
    this.handelrSwiper();
    // 车险暂时隐藏
    // this.homePageGetPersonCarSafeActivityInfo();
  },
  destroyed() {},
  methods: {
    async homePageGetPersonCarSafeActivityInfo() {
      var data = {
        data: {},
      };
      const res = await homePageGetPersonCarSafeActivityInfo(data);
      if (res.code == 0) {
        if (res.data[0]?.onOrOff == 1 || res.data[1]?.onOrOff == 1) {
          this.datalist[0].onOrOff = 1;
        }
      }
    },
    //
    handelrSwiper() {
      var swiper = new Swiper(".swiper-container", {
        slidesPerView: 2,
        spaceBetween: 20,
        slidesPerGroup: 1,
        observer: false,
        loop: false,
        loopFillGroupWithBlank: false,

        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      });
    },
    // 点击跳转活动详情
    handelClick(item) {
      console.log(item , 'item')
      if (item.id&&item.onOrOff!='0') {
        this.$router.push("/EventDetails");
      }else if(item.id){
         this.$tool.PromptBox("error", '活动暂未开启');
      }
    },
  },
};
</script>

<style scoped lang="less">
.box1 {
  width: 100%;
  height: 100%;
  display: flex;
}
.Core {
  max-width: 1184px;
  min-height: 600px;
  margin: auto;
  display: flex;
  flex-direction: column;
  .swiper-container {
    width: 100%;
    margin: auto;
    // border: 1px solid gold;
  }
  .swiper-slide {
    font-size: 18px;
    background-color: #ffffff;
  }
  .box {
    width: 570px;
    min-height: 380px;
    border-radius: 10px;
    background: #ffffff;
    border-radius: 20px;
    margin: 10px;
    box-shadow: 0px 0px 10px 0px rgba(125, 125, 125, 0.5);
    cursor: pointer;
    .picture {
      width: 100%;
      height: 250px;
      // background: #eeeeee;
      border-radius: 20px 20px 0 0;

      img {
        width: 100%;
        min-height: 100%;
      }
    }
    .Instructions {
      width: 100%;
      min-height: 150px;
      box-sizing: border-box;
      border-radius: 0 0 20px 20px;
      display: flex;
      .Instructions-box {
        width: 100%;
        margin: 20px 30px 30px 20px;
        display: flex;
        flex-direction: column;
        align-content: space-between;
        p {
          height: 20px;
          line-height: 20px;
          font-family: PingFangSC-Medium;
          font-weight: 400;
          font-size: 14px;
          color: #666666;
          letter-spacing: 1px;
        }
        p:nth-child(1) {
          height: 25px;
          line-height: 25px;
          font-size: 14px;
          display: flex;
          position: relative;
          font-size: 20px;
          color: #333333;
          // margin-bottom: 16px;
          margin: auto 0;
          span {
            width: 60px;
            height: 25px;
            line-height: 25px;
            background: #409eff ;
            border-radius: 5px;
            font-size: 12px;
            color: #ffffff;
            text-align: center;
            position: absolute;
            right: 15px;
          }
        }
        p:nth-child(2) {
          margin-bottom: 15px;
        }
      }

      .more {
        width: 100%;
        height: 30px;
        margin: auto !important;
        font-size: 28px !important;
        color: #666666;
        text-align: center;
        // color: #ff914d;
      }
    }
  }
}
</style>
